import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IUserFlowState {
  contactGroup: string | null;
  role: string | null;
  rolePermissions: {
    [key: string]: ITilePermissions;
  };
  loading: boolean;
  error: string | null;
}

const initialState: IUserFlowState = {
  contactGroup: null,
  role: null,
  rolePermissions: {},
  loading: false,
  error: null,
};

const userFlowSlice = createSlice({
  name: "userFlow",
  initialState,
  reducers: {
    setUserFlow: (
      state,
      action: PayloadAction<{
        contactGroup: string;
        role: string;
        rolePermissions: IUserFlowState["rolePermissions"];
      }>
    ) => {
      state.contactGroup = action.payload.contactGroup;
      state.role = action.payload.role;
      state.rolePermissions = action.payload.rolePermissions;
    },
    resetUserFlow: (state) => {
      state.contactGroup = null;
      state.role = null;
      state.rolePermissions = {};
      state.error = null;
    },
  },
});


export const { setUserFlow, resetUserFlow } = userFlowSlice.actions;
export default userFlowSlice.reducer;